var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14980_54117)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14980_54117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0015 7.19763C9.74847 7.19763 9.53139 7.11373 9.35031 6.94594C9.17181 6.77549 9.08264 6.57174 9.08264 6.33469C9.08264 6.10032 9.17181 5.89924 9.35031 5.73145C9.53139 5.56099 9.74847 5.47577 10.0015 5.47577C10.2545 5.47577 10.4702 5.56099 10.6486 5.73145C10.8298 5.89924 10.9203 6.10032 10.9203 6.33469C10.9203 6.57174 10.8298 6.77549 10.6486 6.94594C10.4702 7.11373 10.2545 7.19763 10.0015 7.19763Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14661 8.40533V14.125H10.8484V8.40533H9.14661Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 9.99999C18.3334 14.6023 14.6024 18.3333 10 18.3333C5.39765 18.3333 1.66669 14.6023 1.66669 9.99999C1.66669 5.39761 5.39765 1.66666 10 1.66666C14.6024 1.66666 18.3334 5.39761 18.3334 9.99999ZM16.6667 9.99999C16.6667 13.6819 13.6819 16.6667 10 16.6667C6.31812 16.6667 3.33335 13.6819 3.33335 9.99999C3.33335 6.31809 6.31812 3.33332 10 3.33332C13.6819 3.33332 16.6667 6.31809 16.6667 9.99999Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14980_54117)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#535353"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14980_54117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.149428810b27734c76561e42b42e1dcc.svg";
export { ForwardRef as ReactComponent };